import React from "react";
import "./Tables.css";

const LabsTable = ({ labs }) => {
  if (!labs || labs.length === 0) return <p>Нет лабораторных работ.</p>;

  return (
    <div className="table-container">
      <div className="scrollable-table">
        <table className="main-table">
          <thead>
            <tr>
              <th className="table-th table-th-left" style={{ width: "60px" }}>№</th>
              <th className="table-th table-th-left" style={{ width: "80px" }}>Дата</th>
              <th className="table-th table-th-left" style={{ width: "100px" }}>Название</th>
              <th className="table-th table-th-left" style={{ width: "100px" }}>Тема</th>
              <th className="table-th table-th-left" style={{ width: "400px" }}>Задания</th>
            </tr>
          </thead>
          <tbody>
            {labs && labs.map((lab) => (
              <tr key={lab.id}>
                <td className="table-td" style={{ width: "60px" }}>{lab.number}</td>
                <td className="table-td" style={{ width: "80px" }}>{lab.date}</td>
                <td className="table-td" style={{ width: "100px" }}>{lab.name}</td>
                <td className="table-td" style={{ width: "100px" }}>{lab.theme}</td>
                <td className="table-td" style={{ width: "400px" }}>{lab.tasks}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LabsTable;
